<section class="shiksha-deals-at-risk" [attr.aria-label]="content.ariaLabel">
    <header class="shiksha-deals-at-risk__header">
        <app-shiksha-dashboard-subtitle-header
            [title]="content.title"
            [subtitle]="content.subtitle"
            [iconName]="uiConfig.titleIconName"
            [iconVariant]="'alert'"
            [iconSize]="uiConfig.titleIconSize"
        />
    </header>

    @if (hasItems()) {
        <div class="shiksha-deals-at-risk__grid">
            @for (item of items(); track item.stageCode) {
                <article class="shiksha-deals-at-risk__card">
                    <div class="shiksha-deals-at-risk__card-head">
                        <p class="shiksha-deals-at-risk__stage">{{ item.stageCode }}</p>
                        <span class="shiksha-deals-at-risk__alert-icon" aria-hidden="true">
                            <svg viewBox="0 0 24 24" focusable="false">
                                <path
                                    d="M12 3c.38 0 .73.2.92.52l8.4 14.5a1.06 1.06 0 0 1-.92 1.58H3.6a1.06 1.06 0 0 1-.92-1.58l8.4-14.5A1.06 1.06 0 0 1 12 3Zm0 5.3a1 1 0 0 0-1 1v4.5a1 1 0 1 0 2 0V9.3a1 1 0 0 0-1-1Zm0 8.7a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Z"
                                />
                            </svg>
                        </span>
                    </div>
                    <div
                        class="shiksha-deals-at-risk__metrics"
                        [class.shiksha-deals-at-risk__metrics--pair]="
                            !!item.totalLostDealValueDisplay
                        "
                    >
                        <p class="shiksha-deals-at-risk__count">{{ item.lostDeals }}</p>
                        @if (item.totalLostDealValueDisplay) {
                            <span class="shiksha-deals-at-risk__pair-sep" aria-hidden="true"
                                >|</span
                            >
                            <p class="shiksha-deals-at-risk__value">
                                {{ item.totalLostDealValueDisplay }}
                            </p>
                        }
                    </div>
                </article>
            }
        </div>
    } @else {
        <div class="shiksha-deals-at-risk__empty">
            <p class="shiksha-deals-at-risk__empty-title">{{ content.emptyTitle }}</p>
            <p class="shiksha-deals-at-risk__empty-text">{{ content.emptyMessage }}</p>
        </div>
    }
</section>
